import { render } from "./BaseBarChart.vue?vue&type=template&id=4d8e9117&scoped=true"
import script from "./BaseBarChart.vue?vue&type=script&lang=js"
export * from "./BaseBarChart.vue?vue&type=script&lang=js"

import "./BaseBarChart.vue?vue&type=style&index=0&id=4d8e9117&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8e9117"]])

export default __exports__